import react from 'react';
import Tilt from 'react-tilt';
import './Logo.css';
import brain from './brain.png';

const Logo=()=>{

	return(

      <div className='ma4 mt0  '>
      	<Tilt className="Tilt br2 shadow-2" options={{ max : 65 }} style={{ height: 120, width: 120 }} >
			 <div className="Tilt-inner pa3"><a href="https://shivangbhardwaj.netlify.app/"><img style={{paddingTop:'10px'}} alt='logo' src={brain}/></a> </div>
		</Tilt>
      </div>

	);



}


export default Logo;










